export default {
  operator: {
    notes: 'Name of operator / service technician role',
    message: 'Operator / Service technician',
  },
  maintenanceManager: {
    notes: 'Name of maintenance / production manager role',
    message: 'Prod. / Maintenance manager',
  },
  siteManager: {
    notes: 'Name of site / plant manager role',
    message: 'Site / Plant manager',
  },
  customerAdmin: {
    notes: 'Name of customer admin role',
    message: 'Customer admin',
  },
  purchaser: {
    notes: 'Name of purchaser role',
    message: 'Purchaser',
  },
  superUser: {
    notes: 'Name of super user role',
    message: 'Super user',
  },
  businessOwner: {
    notes: 'Name of business owner role',
    message: 'Business owner',
  },
  dealerAdmin: {
    notes: 'Name of dealer admin role',
    message: 'Dealer admin',
  },
  serviceManager: {
    notes: 'Name of service manager role',
    message: 'Service manager',
  },
  certifiedTechnician: {
    notes: 'Name of certified technician role',
    message: 'Certified technician',
  },
  regionAdmin: {
    notes: 'Name of region admin role',
    message: 'Region admin',
  },
  backline: {
    notes: 'Name of backline role',
    message: 'Backline',
  },
  ddc: {
    notes: 'Name of DDC role',
    message: 'DDC',
  },
  demo: {
    notes: 'Name of demo role',
    message: 'Demo',
  },
  capability: {
    notes: 'Label for capability',
    message: 'Capability',
    samEgo: {
      notes: 'SAM ego capability',
      message: 'SAM ego',
    },
    accountManagementExternal: {
      notes: 'Account management external capability',
      message: 'Account management, external',
    },
    externalEnterpriseSignOff: {
      notes: 'External enterprise sign off capability',
      message: 'External enterprise sign off',
    },
    yourAccount: {
      notes: 'Your account capability',
      message: 'Your account',
    },
    yourFleet: {
      notes: 'Your Fleet capability',
      message: 'Your Fleet',
    },
    eqConnectivity: {
      notes: 'EQ Connectivity capability',
      message: 'EQ Connectivity',
    },
    eqAiPrediction: {
      notes: 'EQ AI Prediction capability',
      message: 'EQ AI Prediction',
    },
    userMobilityAndTeamResources: {
      notes: 'User mobility & Team resources capability',
      message: 'User mobility & Team resources',
    },
    ecom: {
      notes: 'E-commerce parts and products capability',
      message: 'E-commerce, Parts & Products',
    },
    expertServiceTool: {
      notes: 'expertServiceTool capability',
      message: 'Expert Service Tool',
    },
  },
  readAccess: {
    notes: 'Read access',
    message: 'Read',
  },
  readWriteAccess: {
    notes: 'Read/write access',
    message: 'Read/write',
  },
  roleSelect: {
    placeholder: {
      notes: 'Placeholder text when selecting role',
      message: 'Select role',
    },
    nameMissing: {
      notes: 'Text when selected option does not have a display name',
      message: 'Name missing ({{value}})',
    },
  },
  entitySelect: {
    placeholder: {
      notes: 'Placeholder text when selecting entity',
      message: 'Select where',
    },
  },
};
